import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import '../components/alice-carousel.scss'
import Img from "gatsby-image"

import { Link, graphql, StaticQuery } from 'gatsby'

const PartnerSlider = (props) => {

  let items = []


  props.data.allMarkdownRemark.edges.forEach((item, i) => {

    if (item.node.frontmatter.featuredimage !== null){
    items.push(
      <Link className="partners" to={item.node.fields.slug} style={{display:'flex',justifyContent:'center',width:'100%'}}>
      <img src={item.node.frontmatter.featuredimage.publicURL}
       alt={item.node.frontmatter.title}
       title={item.node.frontmatter.title}
       style={{height:'90px',margin:'20px',width:'180px',objectFit:'contain',objectPosition:'center center'}}
       loading="lazy" />
      </Link>
    )}
  })


  return (
    <>
    <AliceCarousel autoPlay infinite disableButtonsControls={true} items={items} autoPlayInterval="3500"
    responsive={{
      0: {
      items: 1,
  },
  1024: {
      items: 3,
  }}}
    >
    </AliceCarousel>
    </>
  )
}

export default () => (
  <StaticQuery
    query={graphql`
      query SliderPartners {
        allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "partner-post"}}}, sort: {fields: frontmatter___date, order: ASC}) {
          edges {
            node {
              fields {
                slug
              }
              frontmatter {
                templateKey
                date(formatString: "DD. MM. YYYY")
                title
                featuredimage {
                  childImageSharp {
                    fluid(maxWidth: 1000) {
                      srcWebp
                      srcSetWebp
                      src
                      srcSet
                    }
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <PartnerSlider data={data} />}
  />
)
